import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=47c994fc&scoped=true"
import script from "./ErrorCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=47c994fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c994fc",
  null
  
)

export default component.exports